import request from '@/utils/request';

// 获取签章协议列表
export const getAgreementList = (params) => {
  return request({
    url: '/api/core/user_sign_contracts',
    method: 'get',
    params,
  });
};

// 下载签章协议（PDF 二进制流）
export const getAgreementPdf = (data) => {
  return request({
    url: '/api/core/user_sign_contract_download',
    method: 'post',
    data,
    responseType: 'arraybuffer',
  });
};
